import { jsxs, jsx } from "react/jsx-runtime";
import Head from "next/head";
import React from "react";
import { mediaBreakpointHelper, BREAKPOINTS } from "../components/Source/Source.esm.js";
function withPreload(Component, options) {
  const {
    as = "image"
  } = options || {};
  return function WithPreloadComponent(props) {
    const {
      src,
      srcSet,
      media,
      loading = "eager"
    } = props;
    return /* @__PURE__ */ jsxs(React.Fragment, { children: [
      loading === "eager" && /* @__PURE__ */ jsx(Head, { children: /* @__PURE__ */ jsx("link", { rel: "preload", href: src || srcSet, as, media: media ? mediaBreakpointHelper(BREAKPOINTS, media) : void 0 }) }),
      /* @__PURE__ */ jsx(Component, { ...props })
    ] });
  };
}
export {
  withPreload as default
};
